/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component } from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";


@Component({
    selector: 'well-right-side-animation',
    templateUrl: './right-side-animation.component.html',
    styleUrls: ['./right-side-animation.component.scss'],
    imports: [],
    animations: [
        trigger('slideInOutAnimation', [
            state('*', style({
                position: 'absolute',
                top: '50px',
                left: 0,
                right: 0,
                bottom: 0
            })),
            transition(':enter', [
                style({
                    left: '100%',
                }),
                animate('.3s ease-in-out', style({
                    left: 0,
                }))
            ]),
            transition(':leave', [
                animate('.3s ease-in-out', style({
                    left: '100%',
                }))
            ])
        ])
    ],
    host: { '[@slideInOutAnimation]': '' }
})
export class RightSideAnimationComponent {

}
